import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { PrimeNGModule } from './prime-ng/prime-ng.module';
import { ListaComponentesComponent } from './layouts/lista-componentes/lista-componentes.component';
import { HeaderComponent } from './shared/header/header.component';
import { DesplegablesResumenComponent } from './shared/desplegables-resumen/desplegables-resumen.component';
import { FooterComponent } from './shared/footer/footer.component';
import { MenuComponent } from './shared/menu/menu.component';
import { MenuDesplegableComponent } from './shared/menu-desplegable/menu-desplegable.component';
import { KlapComponent } from './layouts/klap/klap.component';
import { ErrorComponent } from './layouts/error/error.component';
import { KlapTartejasComponent } from './layouts/klap-tartejas/klap-tartejas.component';
import { KlapTartejasDatosComponent } from './layouts/klap-tartejas-datos/klap-tartejas-datos.component';
import { DialogComponent } from './shared/dialog/dialog.component';
import { StepsComponent } from './shared/steps/steps.component';
import { RouterModule } from '@angular/router';
import { LoadingComponent } from './shared/loading/loading.component';
import { FileUploadComponent } from './shared/file-upload/file-upload.component';
import { TerminosYCondicionesComponent } from './shared/terminos-y-condiciones/terminos-y-condiciones.component';

@NgModule({
  declarations: [
    ListaComponentesComponent,
    HeaderComponent,
    DesplegablesResumenComponent,
    FooterComponent,
    MenuComponent,
    MenuDesplegableComponent,
    KlapComponent,
    ErrorComponent,
    KlapTartejasComponent,
    KlapTartejasDatosComponent,
    DialogComponent,
    StepsComponent,
    LoadingComponent,
    FileUploadComponent,
    TerminosYCondicionesComponent,
  ],
  imports: [
    PrimeNGModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [
    ListaComponentesComponent,
    HeaderComponent,
    DesplegablesResumenComponent,
    FooterComponent,
    MenuComponent,
    MenuDesplegableComponent,
    KlapComponent,
    ErrorComponent,
    KlapTartejasComponent,
    KlapTartejasDatosComponent,
    StepsComponent,
    LoadingComponent,
    FileUploadComponent,
    TerminosYCondicionesComponent,
  ],
})
export class ComponentsModule {}
